/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const CredentialUpdateAnnotationsRequest: core.serialization.Schema<
    serializers.CredentialUpdateAnnotationsRequest.Raw,
    Omit<Truvity.CredentialUpdateAnnotationsRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()),
});

export declare namespace CredentialUpdateAnnotationsRequest {
    export interface Raw {
        annotations: Record<string, string>;
    }
}
